import { Modal } from "takeat-design-system-ui-kit";
import styled from "styled-components";

export const WaiterPosComponent = styled(Modal)`
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;

  * {
    align-items: center;
    justify-content: center;
    align-content: center;
  }

  header {
    border-radius: 12px 12px 0 0;
    padding: 8px 0;
    background: var(--Takeat-Colors-Primary-Red, #C8131B);
    display: flex;             
    align-items: center;   
    justify-content: center;      
  }

  header > svg {
    width: 83px;
    height: 40px;
  }

  > div {
    width: 587px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px;

    > span:nth-child(2) {
      color: #C8131B;
      text-align: center;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: var(--Headline-Small-Tracking, 0);
    }
  
    > span:nth-child(3) {
      color: #222;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.15px;
    }
  
    > p {
      color: var(--Takeat-Colors-Neutrals-Grey-02, #7A7A7A);
      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; 
      letter-spacing: 0.1px;
      margin: 0;
      padding: 0;
    }
  
    > section {
      border-radius: 12px;
      background: var(--Takeat-Colors-Red-Variations-00, #FAE8E9);
      display: flex;
      padding: 8px 12px;
      justify-content: center;
      align-items: center;
      gap: 10px;
  
      color: var(--Takeat-Colors-Neutrals-Black-01, #222);
      text-align: center;
  
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.1px;
    }
  
    > div {
      color: var(--Takeat-Colors-Neutrals-Black-01, #222);
      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.1px;
      display: flex;
      gap: 8px;
    }

    > button {
      background-color: #C8131B;
    }
  }
`